import { Subject, Observable } from 'rxjs';

export class Loading {
	enabled: boolean = false;
	failed: boolean = false;

	private subjectLoading: Subject<boolean> = new Subject();

	constructor(params = undefined) {
		this.failed = params?.enabled ?? false;
		this.enabled = params?.enabled ?? false;
	}

	begin(): void {
		this.enabled = true;
		this.failed = false;
		this.subjectLoading.next(this.enabled);
	}

	finish(status = true): void {
		this.enabled = false;
		this.failed = !status;
		this.subjectLoading.next(this.enabled);
	}

	isLoading(): boolean {
		return this.enabled;
	}

	onLoading() {
		return this.subjectLoading;
	}
}
